module.exports = __webpack_public_path__ + "media/images/pandemic-era-policies-graph-909bfda8c4454254d952b3d0166b4063.svg";